import {
  cilBellExclamation,
  cilBriefcase,
  cilCalendar,
  cilChartPie,
  cilCheckCircle,
  cilCircle,
  cilCreditCard,
  cilDollar,
  cilFile,
  cilList,
  cilMenu,
  cilNotes,
  cilPeople,
  cilSettings,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilTask,
  cilUser,
  cilWarning
} from '@coreui/icons';

export const iconSubset = {
  cilBellExclamation,
  cilBriefcase,
  cilCalendar,
  cilChartPie,
  cilCheckCircle,
  cilCircle,
  cilCreditCard,
  cilDollar,
  cilFile,
  cilList,
  cilMenu,
  cilNotes,
  cilPeople,
  cilSettings,
  cilSpeech,
  cilSpeedometer,
  cilSpreadsheet,
  cilTask,
  cilUser,
  cilWarning
};
